<div [formGroup]="formGroup" class="flex flex-col w-full" *transloco="let t">
  <mat-form-field [appearance]="appearance" class="fuse-mat-dense flex-auto">
    @if (label) {
      <mat-label>
        {{ (translateLabel ? t(label) : label) | capitalize }}
      </mat-label>
    }

    <input
      matInput
      [autocomplete]="autocomplete"
      [name]="controlName"
      [placeholder]="t(placeholder) | capitalize"
      [formControlName]="controlName"
      [matAutocomplete]="optionsSelect"
      (input)="onChange($event)"
      (click)="onClick($event)"
      [matAutocompleteDisabled]="disableAutocomplete"
      [maxlength]="maxLength"
    />

    @if (icon) {
      <mat-icon matSuffix>
        {{ icon }}
      </mat-icon>
    }

    <mat-autocomplete #optionsSelect="matAutocomplete" [displayWith]="displaySelect">
      @for (option of options$ | async; track $index) {
        <mat-option [value]="option">
          <span class="grid grid-cols-[1fr_120px] items-center gap-2 w-full">
            <span>{{ option?.name }}</span>

            @if (option?.badge) {
              @let badge = option?.badge;
              <mat-chip selected class="place-self-center" [style.background-color]="badge?.color">
                <span class="whitespace-nowrap" [style.color]="badge?.textColor">{{ badge?.label }}</span>
              </mat-chip>
            }
          </span>
        </mat-option>
      }
    </mat-autocomplete>

    @if (validateField.hasErrorValidate(formControl, 'required')) {
      <mat-error>{{ t('required-field') }}</mat-error>
    } @else if (validateField.hasErrorValidate(formControl, 'minlength')) {
      <mat-error>
        {{ t('minimum') | titlecase }}
        {{ validateField.validateLength(formControl, 'minlength') }}
        {{ t('characters') }}
      </mat-error>
    } @else if (validateField.hasErrorValidate(formControl, 'maxlength')) {
      <mat-error>
        {{ t('maximum') | titlecase }}
        {{ validateField.validateLength(formControl, 'maxlength') }}
        {{ t('characters') }}
      </mat-error>
    }
  </mat-form-field>
</div>
